import React from "react";
import "./PageSupportForStartupsLaunchpadTakeOff.css";

export default class PageSupportForStartupsLaunchpadTakeOff extends React.Component {
	// eslint-disable-next-line class-methods-use-this
	render() {
		return (
			<div id="PageSupportForStartupsLaunchpadTakeOff">
				<div className="row spaced-row">
					<div className="col-md-4">
						<div className="title">
							<h6>Accelerators & Incubators</h6>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-shield-alt"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										LUxembourg CYbersecurity Accelerator - LUCYA
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://lhc.lu/lucya",
											"_blank",
										)}>
										More information
									</button>
								</div>
							</div>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-rocket"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										Accelerators & Incubators
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://directory.startupluxembourg.com/investors.accelerators/f/all_slug_locations/anyof_luxembourg/investor_type/anyof_accelerator",
											"_blank",
										)}>
										Open the list
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="row spaced-row">
					<div className="col-md-4">
						<div className="title">
							<h6>Investors</h6>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-money-check-alt"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										Venture Capitals
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://directory.startupluxembourg.com/investors/f/all_slug_locations/anyof_luxembourg/investor_type/anyof_venture%20capital?prominence=multistage_emea_prominence_2022_unique&sort=multistage_emea_prominence_2022_unique&id=61132",
											"_blank",
										)}>
										Open the list
									</button>
								</div>
							</div>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-handshake"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										Business Angels
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://directory.startupluxembourg.com/investors/f/all_slug_locations/anyof_luxembourg/investor_type/anyof_angel%20fund_angel?prominence=multistage_emea_prominence_2022_unique&sort=multistage_emea_prominence_2022_unique&id=61133",
											"_blank",
										)}>
										Open the list
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="row spaced-row">
					<div className="col-md-4">
						<div className="title">
							<h6>Financial aid</h6>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-search"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										For research and development projects
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://guichet.public.lu/en/entreprises/financement-aides/aides-recherche-developpement/rdi/aides-rdi.html",
											"_blank",
										)}>
										More information
									</button>
								</div>
							</div>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-chart-line"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										For first time founders
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://www.houseofentrepreneurship.lu/actualites?tx_ccnews_news%5Baction%5D=show&tx_ccnews_news%5Bcontroller%5D=News&tx_ccnews_news%5Bnews%5D=4170&cHash=028f4d682382871b54a53009048b9ebf",
											"_blank",
										)}>
										More information
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="row spaced-row">
					<div className="col-md-4">
						<div className="title">
							<h6>Support programmes</h6>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-cloud"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										Fit4digital
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://www.luxinnovation.lu/fit-4-digital-transition/",
											"_blank",
										)}>
										More information
									</button>
								</div>
							</div>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-magic"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										Fit4innovation
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://www.luxinnovation.lu/innovate-in-luxembourg/fit-4-performance-programmes/fit-4-innovation/",
											"_blank",
										)}>
										More information
									</button>
								</div>
							</div>
						</div>
					</div>

					<div className="col-md-4 offset-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-leaf"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										Fit4sustainability
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://www.luxinnovation.lu/innovate-in-luxembourg/fit-4-performance-programmes/fit-4-sustainability/",
											"_blank",
										)}>
										More information
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="row spaced-row">
					<div className="col-md-4">
						<div className="title">
							<h6>Competitions</h6>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-star"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										Fit4Start
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://www.startupluxembourg.com/fit-4-start",
											"_blank",
										)}>
										More information
									</button>
								</div>
							</div>
						</div>
					</div>

					<div className="col-md-4">
						<div className="box vertically-centered centered">
							<div className="row">
								<div className="col-md-6 offset-md-3 spaced-row">
									<i className="fas fa-seedling"/>
								</div>

								<div className="col-md-8 offset-md-2">
									<div className="h8 spaced-row">
										JCI Creative Young Entrepreneur Luxembourg
									</div>
								</div>

								<div className="col-md-12">
									<button
										className="small"
										onClick={() => window.open(
											"https://cyel.jci.lu/",
											"_blank",
										)}>
										More information
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
